import { render, staticRenderFns } from "./sellDetailNew.vue?vue&type=template&id=8428aa0a&scoped=true&"
import script from "./sellDetailNew.vue?vue&type=script&lang=js&"
export * from "./sellDetailNew.vue?vue&type=script&lang=js&"
import style0 from "./sellDetailNew.vue?vue&type=style&index=0&id=8428aa0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8428aa0a",
  null
  
)

export default component.exports